import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  handleClick(event) {
    event.preventDefault();
    if (this.processing) {
      return;
    }
    this.toggleLoading(true);
    const sweetAlertOptions = {
      title: "Deseja desfazer a aprovação desse orçamento?",
      text: "",
      html: "",
      type: "question",
      showCancelButton: true,
      confirmButtonText: "OK",
      footer: "Todos pagamentos, boletos e tratamentos referentes a esse orçamento serão excluídos.",
      cancelButtonText: "Cancelar",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return this.handleUndo();
      }
    };
    swal(sweetAlertOptions).then((result) =>  {
      if (result.value) {
        return
      }

      this.toggleLoading(false);
    }).catch((error) => {
      if (error.showConfirmModal) {
        this.confirmUndo(error.html)
      }
    });
  }

  handleUndo(data={}) {
    swal.disableButtons()
    swal.showLoading()
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");

    return new Promise( (resolve, reject) => {
      axios
      .put(
        this.data.get("url"),
        {
          authenticity_token: csrfToken,
          ...data
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken
          }
        }
      )
      .then(response => {
        if(response.status === 200){
          this.undoComplete(response.data)
          resolve()
          return
        }

        Swal.hideLoading()
        Swal.fire({
          title: "Não foi possível processar a solicitação.",
          showConfirmButton: true,
          cancelButtonText: "Cancelar"
        })
        resolve()
      })
      .catch((error) => {
        console.error(error)
        if (error.response.status !== 409) {
          Swal.hideLoading()
          Swal.fire({
            title: "Não foi possível processar a solicitação.",
            showConfirmButton: true,
            cancelButtonText: "Cancelar"
          })
          return
        }
        reject({
          showConfirmModal: true,
          html: error.response.data
        })
      })
      .finally(() => {
        this.toggleLoading(false);
        resolve()
      });
    })
  }

  toggleLoading(toggle) {
    if (this.processing === toggle) {
      return
    }

    this.processing = toggle;
    if (toggle) {
      this.icon = this.element.innerHTML;
      this.element.innerHTML = `<i class="fa fa-spinner fa-spin"></i>`;
      return;
    }

    this.element.innerHTML = this.icon;
  }

  confirmUndo(data){
    const sweetAlertOptions = {
      title: "",
      text: "",
      html: data,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Desfazer mesmo assim",
      footer: "Todos pagamentos, boletos e tratamentos referentes a esse orçamento serão excluídos.",
      cancelButtonText: "Cancelar"
    };
    swal(sweetAlertOptions).then((result) =>  {
      if (result.value) {
        this.handleUndo({confirm_undo: true});
        return
      }

      this.toggleLoading(false);
    });
  }

  undoComplete(newLine){
    const containerElement = this.element.closest('tr')
    const detailsContainer = containerElement.nextElementSibling
    containerElement.insertAdjacentHTML('afterEnd', newLine);
    detailsContainer.remove()
    containerElement.remove()
    Swal.hideLoading()
    swal.close()
    toastr.success("Orçamento desaprovado.")
  }
}
